import CONTRATO_MINUTAS_PARTICIPANTES from '@/graphql/querys/administracion/minutas/contratoMinutasParticipantes.gql';
import AGREGAR_CONTRATO_MINUTA_PARTICIPANTES from '@/graphql/mutations/administracion/minutas/participantes/agregarContratoMinutaParticipantes.gql';
import ACTUALIZAR_CONTRATO_MINUTA_PARTICIPANTE from '@/graphql/mutations/administracion/minutas/participantes/actualizarContratoMinutaParticipante.gql';
import REMOVER_CONTRATO_MINUTA_PARTICIPANTE from '@/graphql/mutations/administracion/minutas/participantes/removerContratoMinutaParticipante.gql';
import CONTRATO_MINUTAS from '@/graphql/querys/administracion/minutas/contratoMinutas.gql';

export default {
  apollo: {
    contratoMinutas: {
      query: CONTRATO_MINUTAS,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    async mixAgregarParticipante() {
      this.mixEsCargando();
      this.enviandoFormulario = true;
      const { participantesGuardar } = this;
      const { idMinuta } = this;
      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_MINUTA_PARTICIPANTES,
          variables: { minutaParticipantes: participantesGuardar },
          update: (store, { data: { agregarContratoMinutaParticipantes } }) => {
            const data = store
              .readQuery({
                query: CONTRATO_MINUTAS_PARTICIPANTES,
                variables: {
                  idMinuta,
                },
              });
            data.contratoMinutasParticipantes.push(...agregarContratoMinutaParticipantes);
            store.writeQuery({
              query: CONTRATO_MINUTAS_PARTICIPANTES,
              variables: {
                idMinuta,
              },
              data,
            });
            this.mixAgregarParticipanteEnMinutas(store,
              idMinuta,
              agregarContratoMinutaParticipantes);
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixEditarParticipante() {
      this.enviandoFormulario = true;
      this.mixEsCargando();
      const { idMinuta } = this.participanteEditar;
      const { id } = this.participanteEditar;
      const { participante } = this;
      await this.$apollo.mutate({
        mutation: ACTUALIZAR_CONTRATO_MINUTA_PARTICIPANTE,
        variables: {
          id,
          minutaParticipante: participante,
        },
        update: (store, { data: { actualizarContratoMinutaParticipante } }) => {
          const data = store
            .readQuery({
              query: CONTRATO_MINUTAS_PARTICIPANTES,
              variables: {
                idMinuta,
              },
            });
          const { contratoMinutasParticipantes } = data;
          const index = contratoMinutasParticipantes
            .findIndex((p) => p.id === actualizarContratoMinutaParticipante.id);
          if (index !== -1) {
            contratoMinutasParticipantes.splice(index, 1, actualizarContratoMinutaParticipante);
          }
          store.writeQuery({
            query: CONTRATO_MINUTAS_PARTICIPANTES,
            variables: {
              idMinuta,
            },
            data,
          });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarParticipante() {
      this.mixEsCargando();
      this.enviadoFormulario = true;
      const idParticipante = this.participanteEliminar.id;
      const { idMinuta } = this.participanteEliminar;
      await this.$apollo.mutate({
        mutation: REMOVER_CONTRATO_MINUTA_PARTICIPANTE,
        variables: {
          id: idParticipante,
        },
        update: (store) => {
          const query = {
            query: CONTRATO_MINUTAS_PARTICIPANTES,
            variables: {
              idMinuta,
            },
          };
          const data = store.readQuery(query);
          const index = data.contratoMinutasParticipantes
            .findIndex(({ id }) => id === idParticipante);
          if (index !== -1) {
            data.contratoMinutasParticipantes.splice(index, 1);
          }
          store.writeQuery({ ...query, data });
          this.mixEliminarParticipanteEnMinutas(store, idMinuta, this.participanteEliminar);
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
    async mixAgregarParticipanteEnMinutas(store, idMinuta, participantes) {
      const { idContrato } = this.$route.params;
      const query = {
        query: CONTRATO_MINUTAS,
        variables: { idContrato },
      };
      const { contratoMinutas } = store.readQuery(query);
      const contratoMinutasCopia = contratoMinutas.slice();
      const minutaEncontrada = contratoMinutasCopia
        .find(({ id }) => id === idMinuta);
      minutaEncontrada.participantes.push(...participantes);
      const index = contratoMinutasCopia
        .findIndex(({ id }) => id === idMinuta);
      if (index !== -1) {
        contratoMinutasCopia.splice(index, 1, minutaEncontrada);
      }
      store.writeQuery({
        ...query,
        data: {
          contratoMinutas: contratoMinutasCopia,
        },
      });
    },
    async mixEliminarParticipanteEnMinutas(store, idMinuta, participante) {
      const { idContrato } = this.$route.params;
      const idParticipante = participante.id;
      const query = {
        query: CONTRATO_MINUTAS,
        variables: { idContrato },
      };
      const { contratoMinutas } = store.readQuery(query);
      const contratoMinutasCopia = contratoMinutas.slice();
      const minutaEncontrada = contratoMinutasCopia
        .find(({ id }) => id === idMinuta);
      let index = minutaEncontrada.participantes
        .findIndex(({ id }) => id === idParticipante);
      if (index !== -1) {
        minutaEncontrada.participantes.splice(index, 1);
      }
      index = contratoMinutasCopia
        .findIndex(({ id }) => id === idMinuta);
      if (index !== -1) {
        contratoMinutasCopia.splice(index, 1, minutaEncontrada);
      }
      store.writeQuery({
        ...query,
        data: {
          contratoMinutas: contratoMinutasCopia,
        },
      });
    },
  },
};
